export interface ProductVariation {
  name: string
  price: string
  sizes: string[]
  colors: { name: string; hex: string }[]
  x: number
  y: number
}

export interface LookbookItem {
  id: string
  title: string
  model: string
  image: string
  gallery: string[]
  description: string
  narrative: string
  products: ProductVariation[]
}

export const lookbookCollections: LookbookItem[] = [
  {
    id: 'shoes',
    title: 'Shoes Collections',
    model: 'Amara N.',
    image:
      'https://images.unsplash.com/photo-1549298916-b41d501d3772?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1549298916-b41d501d3772?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1560343090-f0409e92791a?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1518049362265-d5b2a6b00b37?auto=format&fit=crop&q=80&w=1200',
    ],
    description:
      'Handcrafted footwear blending traditional motifs with modern silhouettes.',
    narrative:
      'Each pair is hand-finished in our Alexandria atelier, drawing from West African beadwork traditions while honoring contemporary form.',
    products: [
      {
        name: 'Beaded Leather Mules',
        price: '$240',
        sizes: ['6', '7', '8', '9', '10'],
        colors: [
          { name: 'Onyx', hex: '#000000' },
          { name: 'Ivory', hex: '#F5F1E8' },
          { name: 'Cognac', hex: '#8B4513' },
        ],
        x: 45,
        y: 65,
      },
      {
        name: 'Ankle Wrap Sandals',
        price: '$180',
        sizes: ['6', '7', '8', '9', '10'],
        colors: [
          { name: 'Gold', hex: '#D4AF37' },
          { name: 'Silver', hex: '#C0C0C0' },
        ],
        x: 60,
        y: 75,
      },
    ],
  },
  {
    id: 'jewelry',
    title: 'Jewelries',
    model: 'Zara K.',
    image:
      'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1535632787350-4e68ef0ac584?auto=format&fit=crop&q=80&w=1200',
    ],
    description: 'Statement pieces inspired by ancestral craftsmanship.',
    narrative:
      'Forged in collaboration with artisans across the diaspora, each piece carries a story of lineage and craft.',
    products: [
      {
        name: 'Gold Filigree Choker',
        price: '$450',
        sizes: ['One Size'],
        colors: [
          { name: 'Gold', hex: '#D4AF37' },
          { name: 'Rose Gold', hex: '#B76E79' },
        ],
        x: 50,
        y: 35,
      },
      {
        name: 'Drop Earrings',
        price: '$120',
        sizes: ['One Size'],
        colors: [{ name: 'Gold', hex: '#D4AF37' }],
        x: 42,
        y: 30,
      },
    ],
  },
  {
    id: 'prom',
    title: 'Prom Dresses',
    model: 'Imani O.',
    image:
      'https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&q=80&w=1200',
      'https://cdn.magicpatterns.com/uploads/7mhXL4wLM3RtBppQHvnPxN/image.png',
      'https://cdn.magicpatterns.com/uploads/vChsCpL21AZ78UvwSRoejp/red_--model.jpg',
      'https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&q=80&w=1200',
    ],
    description: 'High-fashion evening wear for unforgettable moments.',
    narrative:
      'Tailored from silk-blend Kente and hand-finished with French lace, these gowns are made for the unforgettable.',
    products: [
      {
        name: 'Silk Kente Gown',
        price: '$1,200',
        sizes: ['XS', 'S', 'M', 'L', 'XL'],
        colors: [
          { name: 'Crimson', hex: '#DC143C' },
          { name: 'Royal Blue', hex: '#1E3A8A' },
          { name: 'Emerald', hex: '#065F46' },
        ],
        x: 40,
        y: 45,
      },
    ],
  },
  {
    id: 'kente',
    title: 'Kente',
    model: 'Adwoa B.',
    image:
      'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&q=80&w=1200',
      'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png',
      'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&q=80&w=1200',
      'https://cdn.magicpatterns.com/uploads/gLF2b8eF4zmaV83H3cDGAQ/image.png',
    ],
    description:
      'The royal cloth of Ghana, reimagined for the contemporary wardrobe.',
    narrative:
      'Woven by hand in Bonwire, each Kente piece carries symbolic meaning passed down through generations of master weavers.',
    products: [
      {
        name: 'Hand-woven Kente Blazer',
        price: '$850',
        sizes: ['S', 'M', 'L', 'XL'],
        colors: [
          { name: 'Heritage Gold', hex: '#D4A017' },
          { name: 'Royal Green', hex: '#0B6623' },
        ],
        x: 55,
        y: 30,
      },
    ],
  },
  {
    id: 'senegalese',
    title: 'Senegalese',
    model: 'Aïssatou D.',
    image:
      'https://cdn.magicpatterns.com/uploads/22KCh6TGsUuEohd96DVcGs/image.png',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/22KCh6TGsUuEohd96DVcGs/image.png',
      'https://cdn.magicpatterns.com/uploads/gLF2b8eF4zmaV83H3cDGAQ/image.png',
      'https://cdn.magicpatterns.com/uploads/9r3nX71JfeKabU2grgHW7d/image.png',
      'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png',
    ],
    description: 'Elegant Boubous and tailored sets from the heart of Dakar.',
    narrative:
      'Inspired by the elegance of Senegalese formal wear, our Boubous combine flowing silhouettes with intricate embroidery.',
    products: [
      {
        name: 'Embroidered Grand Boubou',
        price: '$950',
        sizes: ['S', 'M', 'L', 'XL'],
        colors: [
          { name: 'Sky', hex: '#5DADE2' },
          { name: 'Bone', hex: '#E8DCC4' },
          { name: 'Coral', hex: '#FF6B6B' },
        ],
        x: 50,
        y: 50,
      },
    ],
  },
  {
    id: 'african-fashion',
    title: 'African Fashion',
    model: 'Nala M.',
    image:
      'https://cdn.magicpatterns.com/uploads/9r3nX71JfeKabU2grgHW7d/image.png',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/9r3nX71JfeKabU2grgHW7d/image.png',
      'https://cdn.magicpatterns.com/uploads/wuY83ouTkEvEoiTmSETLUt/image.png',
      'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png',
      'https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png',
    ],
    description: 'A celebration of pan-African style and textile innovation.',
    narrative:
      'A bold tapestry of Ankara prints, beadwork, and modern tailoring — a love letter to the continent.',
    products: [
      {
        name: 'Ankara Print Trench',
        price: '$580',
        sizes: ['S', 'M', 'L', 'XL'],
        colors: [
          { name: 'Sunset', hex: '#E55934' },
          { name: 'Midnight', hex: '#0A1828' },
        ],
        x: 45,
        y: 40,
      },
    ],
  },
]
